import React from 'react';
import { IconButton, IconButtonProps, InputAdornment } from '@material-ui/core';
import { Star, StarBorder } from '@material-ui/icons';

export type AdornmentStarProps = IconButtonProps & {
  onToggle?: () => void;
  isFilled: boolean;
};

export const StarAdornment = ({
  edge,
  onToggle,
  isFilled,
  disabled = false,
  ...props
}: AdornmentStarProps): JSX.Element => {
  const handleMouseDownAdornment = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
  };

  const handleClick = () => {
    if (!isFilled) {
      onToggle?.();
    }
  };

  return (
    <InputAdornment position="end">
      <IconButton
        onClick={handleClick}
        onMouseDown={handleMouseDownAdornment}
        {...props}
        edge={edge}
        aria-label="star-adornment"
        disabled={disabled}
      >
        {isFilled ? <Star /> : <StarBorder />}
      </IconButton>
    </InputAdornment>
  );
};

export default StarAdornment;
